import { ThemeOptions, createTheme } from '@mui/material/styles'
import { muiConfig } from '@rent/ui/config'

import { MuiCssBaseline } from './MuiCssBaseline'
import { colors } from './colors'
import { typography } from './typography'

export const samsungTheme = createTheme({
  breakpoints: muiConfig.breakpoints,
  palette: colors,
  typography,
  components: {
    ...muiConfig.components,
    MuiCssBaseline,
  },
  ...muiConfig.otherConfig,
} as ThemeOptions)
